import { Box, Container } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { useTurnstile } from '@markku/components'
import { useSearch } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { EmailStep } from './EmailStep'
import { OtpStep } from './OtpStep'
import { WelcomeStep } from './WelcomeStep'

export function WelcomeLogin() {
  const [step, setStep] = useState<'welcome' | 'email' | 'otp'>('welcome')
  const [email, setEmail] = useState('')
  const [turnstileToken, setTurnstileToken] = useState<string>('')
  const searchParams = useSearch({ from: '/' }) as any

  const { containerRef: turnstileRef, reset: resetTurnstile } = useTurnstile({
    sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
    onSuccess: (token) => {
      setTurnstileToken(token)
    },
    onError: () => {
      setTurnstileToken('')
    },
  })

  // Show error message if redirected due to auth issues
  useEffect(() => {
    if (searchParams?.redirect) {
      notifications.show({
        title: 'Kirjautuminen vaaditaan',
        message: 'Sinun täytyy kirjautua jatkaaksesi.',
        color: 'yellow',
      })
    }
  }, [searchParams])

  const handleEmailSuccess = (emailValue: string) => {
    setEmail(emailValue)
    setStep('otp')
  }

  const handleBack = () => {
    if (step === 'otp') {
      setStep('email')
    } else if (step === 'email') {
      setStep('welcome')
    }
  }

  const handleRetry = () => {
    setStep('email')
    resetTurnstile()
  }

  return (
    <Box
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <Container size={420} p={0}>
        {step === 'welcome' && (
          <WelcomeStep onContinue={() => setStep('email')} />
        )}

        {step === 'email' && (
          <EmailStep
            turnstileRef={turnstileRef}
            turnstileToken={turnstileToken}
            resetTurnstile={resetTurnstile}
            setTurnstileToken={setTurnstileToken}
            onBack={handleBack}
            onSuccess={handleEmailSuccess}
          />
        )}

        {step === 'otp' && (
          <OtpStep email={email} onBack={handleBack} onRetry={handleRetry} />
        )}
      </Container>
    </Box>
  )
}
